import type { NormalizedPendingItem } from "../hooks/usePendingActions";
import type { SelfServiceRequest } from "@/features/self/requests/types";
import { isReviseApplicationDetails } from "../types/pending.types";

function resolveRequestType(item: NormalizedPendingItem): string | null {
  if (item.originalType === "leave_application") {
    if (!isReviseApplicationDetails(item.details)) return null;
    const leaveType = item.details.leave_type;
    if (leaveType === "annual") return "annual_leave";
    if (leaveType === "unpaid") return "unpaid_leave";
    if (leaveType === "medical") return "medical_leave";
    return null;
  }
  if (item.originalType === "amendment") return "amendment";
  if (item.originalType === "resignation_letter") return "resignation";
  return null;
}

export function buildSelfServiceRequestFromPending(item: NormalizedPendingItem): SelfServiceRequest | null {
  if (item.actionRequired !== "revise_application") return null;
  if (!isReviseApplicationDetails(item.details)) return null;

  const type = resolveRequestType(item);
  if (!type) return null;

  const details = item.details;

  return {
    id: item.entityId ?? Number(item.id),
    type,
    type_label: { ru: item.subject_ru, kk: item.subject_kk, en: item.subject_en },
    status: "draft",
    status_label: { ru: "Черновик", kk: "Жоба", en: "Draft" },
    application_review_status: "revision",
    application_review_note: details.application_review_note,
    created_at: item.createdAt,
    date_range:
      details.start_date && details.end_date
        ? {
            start_date: details.start_date,
            end_date: details.end_date,
            days_count: details.days_count ?? null,
          }
        : null,
    details: {
      reason: details.reason,
      diagnosis: details.diagnosis,
      last_working_day: details.last_working_day,
      clause_section: details.clause_section,
      effective_date: details.effective_date,
    },
  };
}
